"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var layer_renderer_1 = require("./renderer/layer-renderer");
function AccessLayer(Card, Renderer) {
    return /** @class */ (function (_super) {
        __extends(AccessCard, _super);
        function AccessCard(adapter, node, pluginName) {
            var _this = _super.call(this, adapter, node) || this;
            _this.ViewMap = {};
            _this.renderer = null;
            _this.props = {
                attrs: node.attrs,
                adapter: adapter,
                dispatchUpdate: _this.dispatchUpdate.bind(_this),
                getBoundingClientRect: _this.getBoundingClientRect.bind(_this),
                getPos: _this.getPos,
                isSelected: false,
                wrapDOM: _this.dom,
                state: {}
            };
            return _this;
        }
        AccessCard.prototype.mount = function (_a) {
            var name = _a.name;
            if (this.layers) {
                this.ViewMap = __assign(__assign({}, this.ViewMap), this.layers);
            }
            var renderer = new layer_renderer_1.LayerRenderer(this.adapter, this.dom, this.ViewMap, Renderer, name);
            renderer.mount(this.props);
            _super.prototype.afterMount.call(this, name);
            return (this.renderer = renderer);
        };
        // this will update view
        AccessCard.prototype.update = function (_a) {
            var attrs = _a.attrs, _b = _a.isSelected, isSelected = _b === void 0 ? this.isSelected : _b, isText = _a.isText;
            if (isText === true) {
                return false;
            }
            if (attrs && this.props.attrs) {
                var attrsKeys = Object.keys(attrs);
                var propsAttrsKeys_1 = Object.keys(this.props.attrs);
                if (attrsKeys.length !== propsAttrsKeys_1.length ||
                    (attrsKeys.length && attrsKeys.some(function (key) { return !propsAttrsKeys_1.includes(key); }))) {
                    return false;
                }
            }
            var result = _super.prototype.update.call(this, { attrs: attrs, isSelected: isSelected });
            var isAttrsChange = this.props.attrs !== attrs;
            var isSelectedChange = this.props.isSelected !== isSelected;
            if (isAttrsChange || isSelectedChange) {
                // this to clean vue's observable
                if (isAttrsChange)
                    Object.assign(this.props, { attrs: attrs });
                if (isSelectedChange)
                    Object.assign(this.props, { isSelected: (isSelected && true) || false });
                if (this.renderer) {
                    this.renderer.update(__assign({}, this.props));
                    return true;
                }
            }
            return result;
        };
        // 默认忽略卡片内部的变化，有需要可以覆盖
        AccessCard.prototype.ignoreMutation = function (event) {
            if (this.dom.contains) {
                return this.dom.contains(event.target);
            }
            else {
                return false;
            }
        };
        AccessCard.prototype.destroy = function () {
            _super.prototype.destroy.call(this);
            this.renderer && this.renderer.uninstall();
        };
        return AccessCard;
    }(Card));
}
exports.AccessLayer = AccessLayer;
//# sourceMappingURL=card.js.map